"use client";

import React from "react";
import { Heading } from "@/components/ui/typography";
import Image from "next/image";

const approachItems = [
  "Operate Internationally,",
  "Stay Compliant,",
  "Keep More Of What They Earn.",
];

function TickItem({ text }: { text: string }) {
  return (
    <div className="flex items-center gap-3">
      <img
        className="max-sm:h-[19px] max-sm:w-[19px]"
        src="/company-formation/tick_mark.svg"
        alt="Tick Mark"
      />
      <span className="text-[16px] font-inter font-medium leading-[150%] text-white max-sm:text-[16px]">
        {text}
      </span>
    </div>
  );
}

export default function LookingAhead({ heading = "Looking Ahead" }: { heading?: string } = {}) {
  return (
    <section className="w-full bg-black  pb-[60px]  lg:pb-[120px] px-4 min-[1340px]:px-0">
      <div className="relative max-w-[1200px] mx-auto flex flex-col max-sm:flex-col-reverse lg:flex-row items-center justify-between max-sm:gap-16 gap-10">
        {/* IMAGE BLOCK (NOW RESPONSIVE + ALWAYS VISIBLE) */}
        <div className="w-full lg:flex-1 relative h-[250px] sm:h-[380px] md:h-[450px] lg:h-[482px] max-sm:rounded-[16px] rounded-[30px] ">
          <Image
            src="/about/ahead.webp"
            alt="Hero Visual"
            fill
            className="object-cover rounded-[30px]"
            priority
          />
        </div>
        {/* CONTENT */}
        <div className="w-full lg:flex-1 flex flex-col gap-8">
          {/* TITLE + TEXT */}
          <div className="flex flex-col gap-6">
            <Heading as="h2" variant="section">
              {heading}
            </Heading>

            <p className="text-[16px] font-normal sm:text-[16px] leading-6 text-white/70 font-inter">
              As more businesses become global, the need for efficient
              international structures continues to grow. <br /> MuteTaxes is
              focused on building a simpler, smarter way for founders to:
            </p>
            <div className="mt-8 grid grid-cols-2 gap-x-6 gap-y-5 max-sm:grid-cols-1">
              {approachItems.map((item) => (
                <TickItem key={item} text={item} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
